import * as defaultImport from "@splunk/dashboard-ui";
export * from "@splunk/dashboard-ui";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
